import { gql, useMutation } from '@apollo/client';

import { GET_CONSULTANT_NUMBERS } from './get-consultant-numbers.hook';

export const CREATE_CONSULTANT_NUMBER = gql`
  mutation createConsultantNumber($payload: ConsultantNumberInput!) {
    createConsultantNumber(payload: $payload) {
      _id
    }
  }
`;

export const useCreateConsultantNumber = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createConsultantNumber] = useMutation(CREATE_CONSULTANT_NUMBER, {
    refetchQueries: [GET_CONSULTANT_NUMBERS],
    onCompleted: onSuccess,
  });

  return { createConsultantNumber };
};
